





































































































































































import { mapGetters } from "vuex";
import DatePicker from "@/components/DatePicker.vue";

export default {
  name: "TableDynamicFilter",
  components: {
    DatePicker
  },
  props: {
    value: {
      type: String,
      default: null
    },
    fields: {
      type: Array,
      default: null
    },
    items: {
      type: Array,
      default: null
    },
    filters: {
      type: Object,
      default: {}
    },
    viewName: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      dfilters: this.filters
    };
  },
  computed: {
    ...mapGetters(["getPageOptions", "getPerPage"]),
    hasFilterable() {
      return this.fields.some(x => x.filterable);
    },

    showViewOptions() {
      if (this.viewName != null) {
        return true;
      }

      return false;
    },

    tableViewIsActive() {
      return this.$store.getters.getTableViewIsActive(this.viewName);
    },

    setting() {
      return [
        {
          key: "perPage",
          label: "TableFilter.perPage",
          type: "dropdown",
          selectedValue: this.getPerPage,
          values: this.getPageOptions
        }
      ];
    }
  },
  methods: {
    HandleDropdownClick(event, index, key) {
      if (key == "perPage") {
        if (this.getPageOptions[index]) {
          this.$store.dispatch("pageSet", this.getPageOptions[index]);
        }
      }
    },

    Displaydate(jsonDate) {
      var date = new Date(jsonDate);
      return date.toLocaleDateString();
    },
    switchView() {
      if (this.viewName) {
        this.$store.dispatch("switchView", this.viewName);
      }
    },

    reset() {
      this.dfilters = null;
      this.$emit("filters", this.dfilters);

      this.$refs.checkboxes.forEach(x => (x.checked = false));
      this.$refs.filterDates.forEach(x => (x.value = ""));
    },
    setFilter(fieldKey, option, value) {
      if (value === true) {
        // Creates new object if undefined.
        // Source: https://stackoverflow.com/questions/17643965/automatically-create-object-if-undefined
        this.dfilters = this.dfilters || {};
        this.dfilters[fieldKey] = this.dfilters[fieldKey] || {};
        this.dfilters[fieldKey][option] = value;
        this.$emit("filters", this.dfilters);
        return;
      }

      delete this.dfilters[fieldKey][option];

      if (Object.entries(this.dfilters[fieldKey]).isEmpty()) {
        delete this.dfilters[fieldKey];
      }

      if (Object.entries(this.dfilters).isEmpty()) {
        this.dfilters = null;
      }

      this.$emit("filters", this.dfilters);
    },
    setDateFilter(fieldKey, value) {
      if (value !== "") {
        // Creates new object if undefined.
        // Source: https://stackoverflow.com/questions/17643965/automatically-create-object-if-undefined
        this.dfilters = this.dfilters || {};
        this.dfilters[fieldKey] = {};
        this.dfilters[fieldKey][value] = value;
        this.$emit("filters", this.dfilters);
        return;
      }

      delete this.dfilters[fieldKey];

      this.$emit("filters", this.dfilters);
    },
    getFieldOptions(fieldKey) {
      var items = this.items.map(x => x[fieldKey]);
      return new Set(items);
    }
  }
};
